import { FeedbackLabel, FeedbackLabelType } from 'v2/core/entities/feedback';

export const hasNoLabelPredictionUnits = (label: FeedbackLabel) => {
  switch (label.type) {
    case FeedbackLabelType.Reason:
      return !label.reasonUnits?.length;
    case FeedbackLabelType.Entity:
      return !label.entityUnits?.filter(
        (unit) => unit.startIDx - unit.endIDx !== 0,
      ).length;
    case FeedbackLabelType.Sentiment:
      return !label.sentimentUnits?.length;
    case FeedbackLabelType.Search:
      return !label.matches?.length;
    default:
      return false;
  }
};
